<template>
  <div class="col-12 col-md-3 left-menu">
    <CommunityCard>
      <div class="isim-community-card-header">
        <h5 class="m-0">Admin Menu</h5>
      </div>

      <ul class="list-group">
        <router-link to="/admin/analytics">
          <li
            class="list-group-item d-flex align-items-center"
            v-bind:class="{ active: onAnalytics }"
          >
            <i class="material-icons" style="margin-right: 7px">analytics</i>
            Analytics
          </li>
        </router-link>
        <router-link to="/admin/users">
          <li
            class="list-group-item d-flex align-items-center"
            v-bind:class="{ active: onUsers }"
          >
            <i class="material-icons" style="margin-right: 7px">person</i>Users
          </li>
        </router-link>
        <router-link to="/admin/reported">
          <li
            class="list-group-item d-flex align-items-center"
            v-bind:class="{ active: onReported }"
          >
            <i class="material-icons" style="margin-right: 7px">report</i>
            Reported Posts
          </li>
        </router-link>
        <router-link to="/admin/post">
          <li
            class="list-group-item d-flex align-items-center"
            v-bind:class="{ active: onPost }"
          >
            <i class="material-icons" style="margin-right: 7px">chat</i>
            Post to Everyone
          </li>
        </router-link>
        <router-link to="/admin/reviewmedia">
          <li
            class="list-group-item d-flex align-items-center"
            v-bind:class="{ active: onMediaReview }"
          >
            <i class="material-icons" style="margin-right: 7px">perm_media</i>
            Media to Review
          </li>
        </router-link>
      </ul>
    </CommunityCard>
  </div>
</template>

<script>
import CommunityCard from "@/components/CommunityCard";

export default {
  name: "AdminMenu",
  components: {
    CommunityCard,
  },
  data() {
    return {
      onAnalytics: false,
      onUsers: false,
      onReported: false,
      onPost: false,
      onMediaReview: false,
    };
  },
  beforeMount() {
    switch (this.$route.path) {
      case "/admin/analytics":
        this.onAnalytics = true;
        break;
      case "/admin/users":
        this.onUsers = true;
        break;
      case "/admin/reported":
        this.onReported = true;
        break;
      case "/admin/post":
        this.onPost = true;
        break;
      case "/admin/reviewmedia":
        this.onMediaReview = true;
        break;
    }
  },
};
</script>

<style scoped>
.list-group-item.active {
  color: var(--isim-primary);
}
@media (min-width: 992px) {
  .collapse.dont-collapse-sm {
    display: block;
    height: auto !important;
    visibility: visible;
  }

  .list-group-item a {
    color: #333;
  }
  .list-group-item {
    color: #212529;
  }
}

ul.list-group li:not(:first-child a):not(:last-child a) {
  border-radius: 0px;
}

ul.list-group li :first-child a {
  border-bottom-left-radius: 0px;
}

ul.list-group li:last-child a {
  border-top-left-radius: 0px;
}

.list-group-item {
  border: none;
  margin-bottom: 5px;
  color: var(--isim-light-text);
  margin-left: 0px;
  background: inherit;
  max-height: 2.2rem;
}
</style>
